import { SiteItem } from "../../redux/models/reduxModels";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { FolderView } from "./folderView";
import authModule from "../../../../utilities/AuthModule";
import { SharepointSpServices } from "../../services/SharepointSpServices";
import { logger } from "../../../../utilities/logger";

export class FolderViewWrapper {
    constructor(private siteInfo: SiteItem[], private currentDirectory: IPageSettings) { }

    async canCreateFolder(canViewFolder: boolean): Promise<boolean> {
        if (canViewFolder) {
            const accessToken = await authModule.getSharePointAccessToken();
            const sharepointSpService = new SharepointSpServices(this.currentDirectory.webUrl, accessToken);
            return await sharepointSpService.getDocumentLibraryEnableFolderCreationSetting(this.currentDirectory.sharePointListId);
        }
        return false;
    }

    canViewFolder(): boolean {
        try {
            const view = new FolderView(this.siteInfo, this.currentDirectory);
            return view.canViewFolder();
        } catch (error) {
            logger(error, "folderViewWrapper.ts (canViewFolder)");
            return true;
        }
    };
}